(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["thrill-club-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('thrill-club');
  if (!(dialog instanceof HTMLDialogElement)) return;

  const dismissedKey = 'thrillClubDismissedUntil';
  const joinedKey = 'thrillClubJoined';
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  const form = dialog.querySelector('.thrill-club-popup__form');
  const signup = dialog.querySelector('.thrill-club-popup__signup');
  const successPanel = dialog.querySelector('.thrill-club-popup__success-panel');
  let successLocked = false;
  let allowSuccessClose = false;

  const canShow = () => {
    if (localStorage.getItem(joinedKey) === 'true') return false;
    const dismissedUntil = Number(localStorage.getItem(dismissedKey) || 0);
    return Date.now() > dismissedUntil;
  };

  const open = () => {
    if (!dialog.open) dialog.showModal();
  };

  const close = () => {
    if (successLocked && !allowSuccessClose) return;
    allowSuccessClose = true;
    dialog.close();
  };

  document.addEventListener('thrill:club:open', open);

  dialog.querySelector('.thrill-club-popup__close')?.addEventListener('click', () => {
    if (localStorage.getItem(joinedKey) !== 'true') {
      localStorage.setItem(dismissedKey, String(Date.now() + sevenDays));
    }
    close();
  });

  dialog.querySelector('.thrill-club-popup__shop-discount')?.addEventListener('click', () => {
    allowSuccessClose = true;
  });

  dialog.addEventListener('cancel', (event) => {
    if (successLocked && !allowSuccessClose) event.preventDefault();
  });

  dialog.addEventListener('close', () => {
    if (successLocked && !allowSuccessClose) {
      window.setTimeout(() => {
        if (!dialog.open) dialog.showModal();
      }, 0);
    }
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      if (successLocked) return;
      if (localStorage.getItem(joinedKey) !== 'true') {
        localStorage.setItem(dismissedKey, String(Date.now() + sevenDays));
      }
      close();
    }
  });

  form?.addEventListener('submit', (event) => {
    event.preventDefault();

    const formData = new FormData(form);

    // Switch to the success state immediately so Shopify's anti-spam response
    // can never dismiss or replace the customer-facing popup.
    localStorage.setItem(joinedKey, 'true');
    successLocked = true;
    allowSuccessClose = false;

    const closeButton = dialog.querySelector('.thrill-club-popup__close');
    if (closeButton instanceof HTMLElement) closeButton.hidden = true;
    if (signup instanceof HTMLElement) signup.hidden = true;
    if (successPanel instanceof HTMLElement) successPanel.hidden = false;
    if (!dialog.open) dialog.showModal();

    // Submit the signup to Shopify in the background. Shopify may answer with
    // a captcha/anti-spam page even when it has accepted the subscriber; that
    // response must not affect the visible success state.
    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    }).catch(() => {});
  });

  if (!canShow()) return;

  let shown = false;
  const maybeShow = () => {
    if (shown || !canShow()) return;
    shown = true;
    open();
    window.removeEventListener('scroll', onScroll);
  };

  const onScroll = () => {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= 0.4) maybeShow();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.setTimeout(maybeShow, 15000);
})();
  } catch(e) { console.error(e); }
})();

})();
